import { APP_TYPE, AppType } from "../app.type";
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-root",
  templateUrl: "./routing.component.html",
  styleUrls: ["./routing.component.scss"],
})
export class RoutingComponent implements OnInit, OnDestroy {
  private routeParamsSubscription: Subscription = new Subscription();

  private backgroundRoutes = [
    "login",
    "reset-password",
    "mfa-complete",
    "error",
  ];

  constructor(
    @Inject(APP_TYPE) private app: AppType,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.routeParamsSubscription = this.router.events.subscribe(
      async (event) => {
        if (event instanceof NavigationEnd) {
          if (
            this.backgroundRoutes.some((r) => event.url.includes(r)) ||
            (event.url === "/" && event.urlAfterRedirects === "/login")
          ) {
            this.modalService.dismissAll();
            this.renderer.addClass(this.document.body, "bodyBackground");
          } else {
            this.renderer.removeClass(this.document.body, "bodyBackground");
          }

          this.app.users.creationOpen = false;
          this.app.profile.viewProfile = false;
          this.app.users.currentUserName = "";
        }
      }
    );

    this.renderer.addClass(this.document.body, "bodyBackground");
  }

  ngOnDestroy(): void {
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
  }
}
